import React from "react";
import SingleFeature from "./singleFeature";

import "./style.scss";
import FeaturesWrapper from "./wrapper";

const Features = ({ wrapperProps, data, down }) => {
  if (wrapperProps.horizontal) {
    return (
      <div style={{ marginBottom: "20px" }}>
        <FeaturesWrapper {...wrapperProps}>
          {data.map((item) => (
            <SingleFeature {...item} down={down} />
          ))}
        </FeaturesWrapper>
      </div>
    );
  }
  return (
    <FeaturesWrapper {...wrapperProps}>
      {data.map((item) => (
        <SingleFeature {...item} down={down} />
      ))}
    </FeaturesWrapper>
  );
};

export default Features;
